<template>
  <div>
    <el-card class="box-card">
      <div 
        slot="header" 
        class="clearfix">
        <span>分享好友</span>
      </div>
      <div>
        <el-form
          ref="ruleForm"
          :model="form"
          :rules="rules"
          label-width="100px"
          label-position="right"
        >
          <el-form-item
            :rules="[
              { required: true, message: '请输入标题', trigger: 'blur' },
              {
                min: 1,
                max: 20,
                message: '长度在 1 到 20 个字符',
                trigger: 'blur',
              },
            ]"
            label="标题:"
            prop="name"
            class="title"
          >
            <el-input
              v-model="form.name"
              placeholder="请输入标题"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item 
            label="封面图片:" 
            prop="target_url">
            <ymt-file-upload
              :files="imgfiles"
              item-width="100px"
              refname="uploadimg"
              @addFiles="addfiles"
              @delFiles="deletefiles"
            />
            <p class="tip">图片长宽比是 5:4</p>
          </el-form-item>
          <el-form-item>
            <el-button 
              type="primary" 
              @click="onSubmit">提 交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import YmtFileUpload from '../components/YmtFileUpload'
import { merchant } from '@/api'
import { Message } from 'element-ui'
import configDataMap from '../config/other-config'

export default {
  name: 'AuthMessage',
  components: {
    YmtFileUpload,
  },
  data() {
    return {
      files: {},
      form: {
        name: '',
        target_url: '',
      },
      rules: {
        abstract: [
          { required: true, message: '请输入摘要', trigger: 'blur' },
          { max: 20, message: '摘要20字符以内', trigger: 'blur' },
        ],
        target_url: [
          { required: true, message: '请选择封面图片', trigger: 'change' },
        ],
      },
      updateid: 0,
      imgfiles:[]
    }
  },
  computed: {
    merchantId() { 
      return configDataMap[this.$route.params.place].merchant
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    onSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.form.target_url) {
            let param = {}
            let apiname = ''
            if (this.updateid) {
              apiname = 'updateMerchantList'
              param = Object.assign(
                this.form,
                {
                  id: this.updateid,
                }
              )
            } else {
              apiname = 'addMerchantList'
              param = Object.assign(
                this.form,
                {
                  page_id: this.merchantId,
                  type: 1, //商家1 产地2
                  area_type: 6,
                }
              )
            }
            merchant[apiname](param).then((res) => {
              if (res) {
                // 重新获取下数据
                this.getList()
                Message.success({
                  message: '上传成功',
                })
              }
            })
          } else {
            Message.info({
              message: '请上传图片',
            })
          }
        }
      })
    },
    addfiles(e) {
      if (e) {
        this.imgfiles.push(e)
        this.$set(this.form, 'target_url', e.icon_url)
      }
    },
    deletefiles(i) {
      this.imgfiles = []
      this.$set(this.form, 'target_url', '')
    },
    getList() {
      merchant
        .getMerchantList({
          page_id: this.merchantId, //商家id
          status: 0,
        })
        .then((res) => {
          if (res.status === 200 && res.data.data) {
            this.files = res.data.data.filter((item) => item.area_type === '6')
            if (this.files) {
              const file = this.files[0]
              this.updateid = file.id
              this.form = {
                name:file.name,
                target_url: file.target_url,
              }
              this.imgfiles = [
                {
                  id: file.id,
                  icon_url: file.target_url,
                },
              ]
            }
          }
        })
    },
  },
}
</script>

<style scoped lang="less">
.box-card {
  margin-top: 20px;
}
.title{
  width: 500px;
}
.upload_area {
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 90px;
  height: 90px;
  background: #f2f2f2;
  border-radius: 2px;
  font-size: 12px;
  color: #333333;
  cursor: pointer;
  > img {
    width: 24px;
    height: 24px;
  }
}
.tip {
  color: #666;
  font-size: 12px;
}
</style>